// Variant Preselection Script
// Automatically selects "4 Bottles" variant when page loads and no variant is selected
// Follows best practices: proper timing, fallbacks, and error handling

(function() {
  'use strict';
  
  // Configuration
  const CONFIG = {
    targetVariant: '4 Bottles',
    maxRetries: 10,
    retryDelay: 100,
    selectors: {
      // Radio button variants (pill style)
      radioVariants: 'input[type="radio"][name*="Quantity"], input[type="radio"][name*="Size"], input[type="radio"][name*="Option"]',
      // Dropdown variants
      dropdownVariants: 'select[name*="options[Quantity]"], select[name*="options[Size]"], select[name*="options[Option]"]',
      // Check if any variant is already selected
      selectedRadio: 'input[type="radio"]:checked',
      selectedDropdown: 'select option:checked'
    }
  };

  // Utility function to wait for elements
  function waitForElement(selector, maxWait = 5000) {
    return new Promise((resolve, reject) => {
      const startTime = Date.now();
      
      function check() {
        const element = document.querySelector(selector);
        if (element) {
          resolve(element);
          return;
        }
        
        if (Date.now() - startTime > maxWait) {
          reject(new Error(`Element not found: ${selector}`));
          return;
        }
        
        requestAnimationFrame(check);
      }
      
      check();
    });
  }

  // Main preselection function
  function preselectFourBottles() {
    try {
      console.log('🔄 Attempting to preselect "4 Bottles" variant...');
      
      // Find all variant options
      const radioVariants = document.querySelectorAll(CONFIG.selectors.radioVariants);
      const dropdownVariants = document.querySelectorAll(CONFIG.selectors.dropdownVariants);
      
      if (radioVariants.length === 0 && dropdownVariants.length === 0) {
        console.log('⚠️ No variant options found');
        return false;
      }
      
      let fourBottlesFound = false;
      let preselectionSuccessful = false;
      
      // Handle radio button variants
      radioVariants.forEach(radio => {
        if (radio.value === CONFIG.targetVariant) {
          fourBottlesFound = true;
          
          // Check if any variant is already selected
          const form = radio.closest('form');
          const anySelected = form ? form.querySelector(CONFIG.selectors.selectedRadio) : document.querySelector(CONFIG.selectors.selectedRadio);
          
          if (!anySelected) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
            preselectionSuccessful = true;
            console.log('✅ Radio button "4 Bottles" preselected');
          } else {
            console.log('ℹ️ Variant already selected, skipping radio preselection');
          }
        }
      });
      
      // Handle dropdown variants
      dropdownVariants.forEach(select => {
        const fourBottlesOption = Array.from(select.options).find(option => 
          option.value === CONFIG.targetVariant
        );
        
        if (fourBottlesOption) {
          fourBottlesFound = true;
          
          // Check if any option is already selected
          if (!select.value || select.value === '') {
            fourBottlesOption.selected = true;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            preselectionSuccessful = true;
            console.log('✅ Dropdown "4 Bottles" preselected');
          } else {
            console.log('ℹ️ Dropdown already has selection, skipping preselection');
          }
        }
      });
      
      if (!fourBottlesFound) {
        console.log(`⚠️ Target variant "${CONFIG.targetVariant}" not found`);
        return false;
      }
      
      if (preselectionSuccessful) {
        console.log('🎉 Variant preselection completed successfully');
      } else {
        console.log('ℹ️ Preselection skipped - variant already selected');
      }
      
      return preselectionSuccessful;
      
    } catch (error) {
      console.error('❌ Error during variant preselection:', error);
      return false;
    }
  }

  // Enhanced initialization with retry logic
  function initializePreselection() {
    let attempts = 0;
    
    function attemptPreselection() {
      attempts++;
      
      if (preselectFourBottles()) {
        console.log('✅ Variant preselection successful on attempt', attempts);
        return;
      }
      
      if (attempts < CONFIG.maxRetries) {
        console.log(`🔄 Attempt ${attempts} failed, retrying in ${CONFIG.retryDelay}ms...`);
        setTimeout(attemptPreselection, CONFIG.retryDelay);
      } else {
        console.log('⚠️ Max retry attempts reached, falling back to Liquid preselection');
      }
    }
    
    // Start the retry process
    attemptPreselection();
  }

  // Event listeners
  function setupEventListeners() {
    // Initial load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializePreselection);
    } else {
      // DOM already loaded
      initializePreselection();
    }
    
    // Handle page visibility changes (user returns to tab)
    document.addEventListener('visibilitychange', function() {
      if (!document.hidden) {
        // Small delay to ensure page is fully active
        setTimeout(preselectFourBottles, 100);
      }
    });
    
    // Handle dynamic content changes (for SPAs or dynamic loading)
    if (typeof MutationObserver !== 'undefined') {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            // Check if variant options were added
            const hasVariants = Array.from(mutation.addedNodes).some(node => 
              node.nodeType === 1 && (
                node.querySelector && node.querySelector(CONFIG.selectors.radioVariants) ||
                node.querySelector && node.querySelector(CONFIG.selectors.dropdownVariants)
              )
            );
            
            if (hasVariants) {
              console.log('🔄 Variant options detected, attempting preselection...');
              setTimeout(preselectFourBottles, 50);
            }
          }
        });
      });
      
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  // Initialize when script loads
  setupEventListeners();
  
})();
